import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError,retry } from 'rxjs/operators';
import { PurchaseTransaction } from './purchase-transaction';
import { euCs, sPrices, localPostcodes } from './products';


@Injectable({
  providedIn: 'root'
})
export class BasketService {
  items = [];
  shippingAddress;
  euCountries = euCs;
  localPostcodes = localPostcodes;
  rate;
  serverData;
  shippingCost;
  shippingPrices = sPrices;

  constructor(
    private http: HttpClient
  ) { }

  addToBasket(product) {
    // does this item exist in our basket already?
    for ( let item of this.items ) {
      if (product.name === item.name) {
        item.quantity++;
        return;
      }
    }
    //if not add it
    product.quantity = 1;
    this.items.push(product);
  }

  getItems() {
    return this.items;
  }

  removeFromBasket(itemName) {
    const items = this.items;
    for (var i=0; i<items.length; i++) {
      if (items[i].name === itemName) {
        items[i].quantity--;
        if (items[i].quantity === 0) {
          this.items.splice(i,1);
        }
        break;
      }
    }
  }

  clearBasket() {
    this.items = [];
    return this.items;
  }

  getShippingCost() {
    let rate = this.rate;
    rate = this.getShippingRate();
    if (rate == null){
      return 0;
    }
    
    const shippingPrices = this.shippingPrices;
    //console.log("shipping prices: ",shippingPrices);
    const factor = shippingPrices[this.rate].price;

    this.shippingCost = Math.floor((this.getNumberOfItems()/4) + 1) * factor; 
    if (factor !== 0 && this.getNumberOfItems()>=2) {
      this.shippingCost+=2;
    }

    if(this.getTotalCost()<=5 && this.shippingCost!==0) {
      this.shippingCost--;
    }
    return this.shippingCost;
  }

  getShippingPrices() {
    return this.shippingPrices;
  }

  getNumberOfItems() {
    let noOfItems = 0;
    for ( let item of this.items ) {
      noOfItems+=item.quantity;
    }
    return noOfItems;
  }

  getTotalCost()
  {
    let totalCost=0;
    for ( let item of this.items ) {
      totalCost+=item.price*item.quantity;
    }
    return totalCost;
  }

  setShippingAddress(address) {
    this.shippingAddress = address;
  }

  getShippingAddress() {
    return this.shippingAddress;
  }

  getShippingRate() {
    if (this.shippingAddress == null) {
      return null;
    }
    const country = this.shippingAddress.country;
    const postcode = this.shippingAddress.postcode;

	  if (country === 'United Kingdom') {
      this.rate = 'uk';

      if (postcode) {
        for (let j=0; j<this.localPostcodes.length; j++) {
          if(postcode === localPostcodes[j]) {
            this.rate = 'local';
          }
        }
      }
    } 
    else {
      let isEu = false;
      for (var i=0; i<this.euCountries.length; i++){
        if (this.euCountries[i] === country) {
          this.rate = 'eu';
          isEu = true;
          break;
        }  
      }
      if (!isEu) {
        this.rate = 'ww';
      }
    }
    return this.rate;
  }

  purchase (): Observable<PurchaseTransaction> {
    this.shippingAddress.shippingCost = this.shippingCost;
    this.shippingAddress.shippingRate = this.rate;

    return this.http.post<PurchaseTransaction>
      (
        '/servlets/purchase',
        {
          "shipping": this.shippingAddress, 
          "products": this.items
        }//, httpOptions
      )
      .pipe(
        retry(3), // retry a failed request up to 3 times
        catchError(
          this.handleError
        ));
  }

  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Sorry, the CEBac store is not working properly at the moment. Please try again later.');
    }
}
